import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import { translate } from "react-i18next";
import React, { useState, useEffect } from 'react';
import TextInput from '../../../../../components/TextInput';

const Table = styled.table`
    width: 80%;
    height: calc(100% - 4px);
    border-collapse: collapse;
    th {
        text-align: left;
        border-bottom: 2px solid #265a9c;
    };
    tr {
        font-size: 15px;
    };
    tr:last-child {
        border-bottom: 2px solid #265a9c;
        padding-bottom: 10px;
    };
    tr:last-child>td {
        padding-bottom: 10px;
    };
    td {
        padding: 10px 0 0 10px;
    };
`;

const UserAssigmentAdmin = ({userAssignmentList, t} ) => {
    const [customerFilter, setCustomerFilter] = useState("");
    const [workspaceFilter, setWorkspaceFilter] = useState("");
    const [userFilter, setUserFilter] = useState("");
    const [userAssignments, setUserAssignments] = useState([]);

    useEffect( () => {
        setUserAssignments(userAssignmentList.filter( ({customerName, workspaceName ,userName}) => 
            {return(
                customerName.toLowerCase().indexOf(customerFilter.toLowerCase())>-1
                && workspaceName.toLowerCase().indexOf(workspaceFilter.toLowerCase())>-1
                && userName.toLowerCase().indexOf(userFilter.toLowerCase())>-1
            )}
        ));
    },[customerFilter,workspaceFilter,userFilter,userAssignmentList])

    const renderDataRow = ({customerName, workspaceName, userName}) => {
        return(
            <tr key={`${customerName}_${workspaceName}_${userName}_row`}>
                <td>
                    {customerName}
                </td>
                <td>
                    {workspaceName}
                </td>
                <td>
                    {userName}
                </td>
            </tr> 
        )
    }
    return (
    <Table>
        <thead>
            <tr>
                <th>{t('Customer name')}</th>
                <th>{t('Workspace name')}</th>
                <th>{t('User name')}</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>
                    <TextInput
                        style={{ alignItems: 'flex-start'}}
                        placeholder={t('Customer filter')+'...'}
                        value={customerFilter}
                        onChange={(e) => {
                            setCustomerFilter(e.target.value)
                        }}/>
                </td>
                <td>
                    <TextInput
                        style={{ alignItems: 'flex-start'}}
                        placeholder={t('Workspace filter')+'...'}
                        value={workspaceFilter}
                        onChange={(e) => {
                            setWorkspaceFilter(e.target.value)
                        }}/>
                </td>
                <td>
                    <TextInput
                        style={{ alignItems: 'flex-start'}}                    
                        placeholder={t('User filter')+'...'}
                        value={userFilter}
                        onChange={(e) => {
                            setUserFilter(e.target.value)
                        }}/>
                </td>
            </tr>
            {userAssignments.map(row => renderDataRow(row))}
        </tbody>
    </Table>
)
}

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance')
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(UserAssigmentAdmin));



// WEBPACK FOOTER //
// ./src/containers/content/grid/adminPanel/userAssignmentAdmin/UserAssigmentAdmin.jsx